import { isTestnet } from "../constants/envs";

export const TOKEN_ACCOUNT = isTestnet ? 'boomfungible' : 'csboomcsboom';
export const MINTER_ACCOUNT = isTestnet ? 'crypshotsnft' : 'crypto4shots';
